import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Necesito un gimnasio?',
  a: 'No, puedes adaptar los principios en casa o en el gym.'
}, {
  q: '¿Funciona con anticonceptivos?',
  a: 'Sí, te enseñamos a crear un ciclo sintético de descarga para bajar la inflamación.'
}, {
  q: '¿Cuánto tiempo toma ver resultados?',
  a: 'Sentirás menos hinchazón en 7 días; los cambios físicos reales se consolidan en el primer ciclo completo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-emerald-900 relative" data-id="element-24">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-25">
        <FadeIn data-id="element-26">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-27">
            PREGUNTAS <span className="text-gradient-gold" data-id="element-28">FRECUENTES</span>
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-29">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <FadeIn key={index} delay={0.1 * index} data-id="element-30">
                <div className="bg-emerald-950 border border-emerald-800/50 rounded-xl overflow-hidden" data-id="element-31">
                  <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-500" aria-expanded={isOpen} data-id="element-32">
                    <span className="font-heading font-bold text-lg text-emerald-50 pr-4" data-id="element-33">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`w-5 h-5 text-gold-400 transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-34" />
                  </button>

                  <AnimatePresence data-id="element-35">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-36">
                        <div className="px-6 pb-5 pt-0 text-emerald-100/70 font-body leading-relaxed" data-id="element-37">
                          {faq.a}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}